import { DEFAULT_PAGE } from '@anm/data/video-templates/defaults';

import vtConfig from '../../../config';

const { urls } = vtConfig();

export const getPageLink = (pageName: string) =>
  pageName === DEFAULT_PAGE
    ? `${urls.wave}video-templates`
    : `${urls.wave}video-templates/${pageName}`;
